import { Button, Checkbox, Dropdown, Menu } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { useState } from 'react';
import {
  setCitySelection,
  setDistrictSelected,
  setNeighborhoodSelected,
} from '../../../store/requests/zone';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

export const CityDistrictAndNeighborhoodSelection = () => {
  const [visible, setVisible] = useState(false);
  const { selectedCity, selectedDistrict, selectedNeighborhood } =
    useSelector((state) => state?.zone?.cityDistrictAndNeighborhoodSelection) ??
    null;
  const { t } = useTranslation();

  const onChangeSelectedCity = (e) => {
    setCitySelection(e.target.checked);
  };
  const onChangeSelectedDistrict = (e) => {
    setDistrictSelected(e.target.checked);
  };
  const onChangeSelectedNeighborhood = (e) => {
    setNeighborhoodSelected(e.target.checked);
  };

  const menu = (
    <Menu>
      <Menu.Item key="checkbox-group">
        <Checkbox onChange={onChangeSelectedCity} checked={selectedCity}>
          {t('cityName')}
        </Checkbox>
        <Checkbox
          onChange={onChangeSelectedDistrict}
          checked={selectedDistrict}
        >
          {t('districtName')}
        </Checkbox>
        <Checkbox
          onChange={onChangeSelectedNeighborhood}
          checked={selectedNeighborhood}
        >
          {t('neighborhood')}
        </Checkbox>
      </Menu.Item>
    </Menu>
  );

  return (
    <Dropdown
      overlay={menu}
      trigger={['click']}
      open={visible}
      onOpenChange={(flag) => setVisible(flag)}
    >
      <a className="ant-dropdown-link" onClick={(e) => e.preventDefault()}>
        <Button>
          İl, İlçe, Mahalle Göster
          <DownOutlined />
        </Button>
      </a>
    </Dropdown>
  );
};
